import { render, staticRenderFns } from "./PDFTranslate copy.vue?vue&type=template&id=605b937e&scoped=true&"
import script from "./PDFTranslate copy.vue?vue&type=script&lang=js&"
export * from "./PDFTranslate copy.vue?vue&type=script&lang=js&"
import style0 from "./PDFTranslate copy.vue?vue&type=style&index=0&id=605b937e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605b937e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VContainer,VFlex,VIcon,VLayout})
